import Vue from 'vue'
import App from './App.vue'

//加载自定义icon样式
import '@/assets/sys-icons/iconfont.css'

//加载iview
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI)

//加载公共样式
import './assets/css/public.less'

//加载复制插件
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard)

//组织结构图组件
import VOrgTree from 'v-org-tree'
import TreeTable from 'tree-table-vue'
import 'v-org-tree/dist/v-org-tree.css'
Vue.use(VOrgTree)
Vue.use(TreeTable)

//加载公共方法和基础配置文件
import commonFun from "./lib/commonFun";
Vue.prototype.$commonFun = commonFun
import baseConfig from './config/base-config'
Vue.prototype.$config = baseConfig

//全局注册常用组件
import pageTable from './components/table/pageTable.vue'
Vue.component('pageTable', pageTable)

import router from "./router";
import store from "./store"

//注册指令
import importDirective from '@/directive'
import { directive as clickOutside } from 'v-click-outside-x'
importDirective(Vue)
Vue.directive('clickOutside',clickOutside)

//图片预览
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
